export default {
  "content": "<path d=\"M19.207 6.207L9.415 16H17v2H7a1 1 0 01-1-1V7h2v7.586l9.794-9.793 1.413 1.414z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};